// extracted by mini-css-extract-plugin
export var background = "_6p-0";
export var container = "_6p-1";
export var contentItem = "_6p-7";
export var extendedWarranty = "_6p-5";
export var link = "_6p-d";
export var modal = "_6p-b";
export var modalCloseButton = "_6p-9";
export var modalContent = "_6p-3";
export var modalContentMain = "_6p-6";
export var modalImageLogo = "_6p-8";
export var modalLogo = "_6p-a";
export var modalSideImage = "_6p-4";
export var preview = "_6p-c";
export var redoModal = "_6p-2";